import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public details = new BehaviorSubject({});
  public schoolId = new BehaviorSubject(null);
  public priorityType = new BehaviorSubject(null);
  public isLoading = new BehaviorSubject(false);
  public enableUsers = new BehaviorSubject(false);

  constructor() { }
  
  setSpinner(isSpin: boolean) {
    this.isLoading.next(isSpin);
  }

  getSpinner() {
    return this.isLoading;
  }

  setUserMenu(visible: boolean) {
    this.enableUsers.next(visible);
  }

  getUserMenu() {
    return this.enableUsers;
  }

  setUserDetails(value: any) {
    this.details.next(value)
  }

  getUserDetails() {
    return this.details
  }

  setSchoolId(value: any) {
    this.schoolId.next(value)
  }

  getSchoolId() {
    return this.schoolId
  }

}
